import { type CancelationReason } from '@exam-center/graphql';
import { EllipsisText, Flex } from '@shared/components';

import { CANCELATION_REASON_CATEGORIES } from '../../constants';

interface CancelationReasonCellProps {
  cancelationReasonCategory?: CancelationReason | null;
  remark?: string | null;
}

export default function CancelationReasonCell(props: Readonly<CancelationReasonCellProps>) {
  const { cancelationReasonCategory: cancelationReasonCategory, remark } = props;

  if (cancelationReasonCategory) {
    const categoryLabel = CANCELATION_REASON_CATEGORIES.find(
      (c) => c.value === cancelationReasonCategory,
    )?.label;
    if (!categoryLabel) {
      return <EllipsisText>{remark ?? '-'}</EllipsisText>;
    }

    return (
      <Flex sx={{ alignItems: 'center', gap: 0.5, overflow: 'hidden' }}>
        <EllipsisText>{`[${categoryLabel}] ${remark ?? '-'}`}</EllipsisText>
      </Flex>
    );
  }

  return <EllipsisText>{remark ?? '-'}</EllipsisText>;
}
